import { createSvgIcon } from '@mui/material/utils';
import { Component } from 'react';

const SubstituirMembroComposicaoIcon = createSvgIcon(
    <svg>
        <path
            d="M 9.00,9.00
                    C 9.00,9.00 2.00,9.00 2.00,9.00
                        2.00,9.00 2.00,7.00 2.00,7.00
                        2.00,7.00 7.00,7.00 7.00,7.00
                        7.00,7.00 5.00,3.00 5.00,3.00
                        7.91,5.00 9.00,4.78 9.00,9.00 Z
                    M 9.00,10.00
                    C 9.00,10.00 9.00,12.00 9.00,12.00
                        9.00,12.00 4.00,12.00 4.00,12.00
                        4.00,12.00 6.00,16.00 6.00,16.00
                        3.00,13.94 2.00,14.28 2.00,10.00
                        2.00,10.00 9.00,10.00 9.00,10.00 Z
                    M 14.78,13.03
                    C 18.59,13.06 22.91,18.56 22.91,20.91
                        22.91,20.91 5.00,20.94 5.00,20.94
                        4.94,17.88 9.56,13.03 13.91,12.97M 9.97,7.00
                    C 9.97,9.16 12.06,10.97 13.97,10.91
                        16.00,10.97 17.97,9.00 17.97,6.97
                        17.94,4.78 16.25,3.06 14.00,3.06
                        11.62,2.94 9.88,5.16 9.97,7.03M 13.97,12.94
                    C 13.97,12.94 14.06,14.94 14.06,14.94
                        11.56,14.97 9.94,16.53 9.97,19.00
                        9.97,19.00 17.97,19.00 17.97,19.00
                        17.97,16.28 16.19,14.97 14.28,14.94
                        14.28,14.94 14.06,12.97 14.06,12.97"
        />
    </svg>,
    'IconeSubstituirParticipante'
);

class IconeSubstituirParticipante extends Component {
    render() {
        return <SubstituirMembroComposicaoIcon {...this.props} />;
    }
}

export default IconeSubstituirParticipante;
